import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string().required().label('Name'),
  is_active: yup.boolean().label('Active'),
  licenses: yup
      .number()
      .nullable()
      .positive()
      .required()
      .label("Licences")
});
